<template>
	<div class="league-data">
		<div class="mian">
			<div class="league-tab">
				<div v-for="(item, i) in leagueList" class="tab-item" :class="i == leagueTabActive ? 'active' : ''"
					@click="changeLeague(i)">
					{{ item.gb_short }}
				</div>
			</div>
			<div class="league-data-content" v-loading="loading">
				<div class="list-tab">
					<template v-for="item in listTab">
						<div class="tab-item" :class="item.id == listTabActive ? 'active' : ''"
							@click="getListData(item)"> {{ item.title }}</div>
					</template>
				</div>
				<div class="list-data">

					<integral-list :detail="integraldetail" :dataType="dataType"
						v-if="listTabActive == 0"></integral-list>

					<shooter-assists-list :detail="shooterdetail" v-if="listTabActive == 1"
						type="shooters"></shooter-assists-list>

					<shooter-assists-list :detail="shooterdetail" v-if="listTabActive == 2"
						type="assists"></shooter-assists-list>

					<match-list :detail="leagueMatch" :currentRound="currentRound" @changeRound="changeRound"
						v-if="listTabActive == 3"></match-list>

				</div>
			</div>
		</div>
	</div>
</template>

<script>
import axios from "axios";
import dayjs from 'dayjs'
import integralList from "./components/integralList.vue";
import shooterAssistsList from "./components/shooterAssistsList.vue";
import matchList from "./components/matchList.vue";
export default {
	data() {
		return {
			loading: false,
			leagueList: [],
			leagueTabActive: 0,
			listTab: [
				// {title:'积分榜',id:0},
				// {title:'射手榜',id:1},
				// {title:'助攻榜',id:2},
				// {title:'赛程',id:3},
			],
			listTabActive: 0,
			leagueData: [],
			memberData: [],
			leagueMatch: [],
			matchRound: [],
			dataType: 1,
			cate: 2,

			t: dayjs().format('DDHH')
		}
	},
	components: {
		integralList,
		shooterAssistsList,
		matchList
	},
	created() {
		if (this.$route.query.type) {
			this.leagueTabActive = this.$route.query.type
		}
		this.getLeague();
	},


	beforeMount() {

	},
	computed: {
		//积分榜数据处理
		integraldetail() {
			if (this.dataType == 1) {
				let league_group_name = ''
				let arr = []
				let data = this.leagueData.reduce((groups, item) => {
					league_group_name = item.league_group_name
					let key = item.group_name || '排行'
					if (!groups[key]) {
						groups[key] = [];
					}
					groups[key].push(item);
					return groups;
				}, {});
				arr.data = data
				arr.title = league_group_name || '联赛'
				return arr
			}
			if (this.dataType == 2) {
				let arr = []
				let data = this.leagueData.reduce((groups, item) => {
					let key = item.alliance_name
					if (!groups[key]) {
						groups[key] = [];
					}
					groups[key].push(item);
					return groups;
				}, {});
				arr.data = data
				arr.title = '联赛'
				return arr
			}
		},
		//射手榜和助攻榜数据处理
		shooterdetail() {
			if (this.memberData.length <= 0) {
				return []
			}
			if (this.listTabActive == 1) {
				let arr = this.memberData.slice().sort((a, b) => {
					let aTotalGoals = a.goals + a.penalty_goals;
					let bTotalGoals = b.goals + b.penalty_goals;
					return bTotalGoals - aTotalGoals;
				})
				return arr
			} else if (this.listTabActive == 2) {
				return this.memberData
			}

		},
		//联赛当前轮
		currentRound() {
			if (this.matchRound.length > 0) {
				return this.matchRound.find(item => item.is_current);
			} else {
				return {}
			}
		},
		league_id() {
			if (this.leagueList.length > this.leagueTabActive) {
				return this.leagueList[this.leagueTabActive].league_id
			}
			return 0
		}
	},
	methods: {
		setListTab(type) {
			if (type == 1) {
				this.listTab = [
					{ title: '积分榜', id: 0 },
					{ title: '射手榜', id: 1 },
					{ title: '助攻榜', id: 2 },
					{ title: '赛程', id: 3 },
				]
			} else if (type == 2) {
				this.listTab = [
					{ title: '积分榜', id: 0 }
				]
			}
		},
		//切换联赛
		async changeLeague(i) {
			this.loading = true
			this.leagueTabActive = i;
			this.listTabActive = 0
			this.dataType = this.leagueList[this.leagueTabActive].type
			history.replaceState(history.state, '', `?type=${i}`)
			if (this.dataType == 1) {
				await this.getMatchRound()
			}
			this.getListData(this.listTab[this.listTabActive])

		},
		//获取联赛名单数据
		async getLeague() {
			await axios.get("/api/web/ranking/get_league").then(res => {
				this.leagueList = res.data.data
				this.dataType = res.data.data[this.leagueTabActive].type
				this.getLeagueData()
				this.getMatchRound()
			})
		},
		async getListData(item) {
			this.loading = true
			this.listTabActive = item.id
			if (this.dataType == 1) {
				if (item.id == 0) {
					await this.getLeagueData();
				}
				if (item.id == 1 || item.id == 2) {
					this.memberData = []
					this.getMemberData(item.id);
				}
				if (item.id == 3) {
					this.getLeagueMatch()
				}
			} else {
				this.listTabActive = 0
				await this.getLeagueData();
			}
			this.$nextTick(() => {
				this.loading = false
			})
		},
		//获取联赛积分榜数据
		async getLeagueData() {
			await axios.get(`/api/web/ranking/get_league_data?league_id=${this.leagueList[this.leagueTabActive].league_id}&type=${this.dataType}`).then(res => {
				this.leagueData = res.data.data
				this.setListTab(this.dataType)
			})
		},
		//
		async getMemberData(id) {
			await axios.get(`/api/web/ranking/get_member_data?league_id=${this.leagueList[this.leagueTabActive].league_id}&rank_type=${id}`).then(res => {
				this.memberData = res.data.data
			})
		},
		// &current_round=${this.currentRound.current_round}
		async getLeagueMatch(id) {
			let url = `/api/web/ranking/get_match?league_id=${this.leagueList[this.leagueTabActive].league_id}&type=${this.dataType}&season=${this.currentRound.season}&round_id=${this.currentRound.round_id}`
			if (this.currentRound.cate == 1) {
				url += `&current_round=${this.currentRound.current_round}`
			}
			await axios.get(url).then(res => {
				this.leagueMatch = res.data.data
			})
		},
		async getMatchRound() {
			await axios.get(`/api/web/ranking/get_match_round?league_id=${this.leagueList[this.leagueTabActive].league_id}&type=${this.dataType}`).then(res => {
				console.log(res);
				if (res.data.data.length > 0) {
					this.matchRound = res.data.data.map((item, index) => ({
						...item,
						hasPrev: index !== 0,
						hasNext: index !== res.data.data.length - 1
					}));
				} else {
					this.matchRound = []
				}

			})
		},
		changeRound(type) {
			console.log(type);
			const currentIndex = this.matchRound.findIndex(item => item.is_current == 1);
			if (type == 'next') {
				this.$set(this.matchRound[currentIndex], 'is_current', 0);
				const nextIndex = (currentIndex + 1) % this.matchRound.length;
				this.$set(this.matchRound[nextIndex], 'is_current', 1);
			} else {
				this.$set(this.matchRound[currentIndex], 'is_current', 0);
				const prevIndex = (currentIndex - 1 + this.matchRound.length) % this.matchRound.length;
				this.$set(this.matchRound[prevIndex], 'is_current', 1);
			}
			this.getLeagueMatch()
			console.log(this.currentRound);
		}
	},
}
</script>

<style lang="less" scoped>
.league-data {
	font-size: 16px;

	.mian {
		width: 1200px;
		margin: 0 auto;
		padding-top: 50px;
		display: flex;
		align-items: flex-start;

		.league-tab {
			width: 195px;
			margin-right: 60px;

			.tab-item {
				height: 48px;
				line-height: 48px;
				padding-left: 10px;
				border-left: 5px solid #fff;
				cursor: pointer;

				&:hover {
					background: #f5dcde;
					color: #e24949;
					transition: none;
					border-left-color: #e24949;
				}
			}

			.active {
				background: #f5dcde;
				color: #e24949;
				transition: none;
				border-left-color: #e24949;
			}
		}

		.league-data-content {
			width: 940px;
			align-self: auto;

			.list-tab {
				display: flex;
				align-items: center;
				justify-content: center;
				// width: 420px;
				line-height: 40px;
				text-align: center;
				margin: 0 auto 18px;

				.tab-item {
					width: 140px;
					text-align: center;
					cursor: pointer;
				}

				.active {
					color: #e24949;
					position: relative;

					&::before {
						content: "";
						width: 42px;
						height: 4px;
						background: #e24949;
						border-radius: 4px;
						position: absolute;
						bottom: 0;
						left: 49px;
					}
				}
			}

			.list-data {
				width: 100%;

				.title {
					width: 100%;
					height: 50px;
					line-height: 50px;
					text-align: center;
					color: #fff;
					background: #e24949;
					font-size: 18px;
				}

				thead tr {
					border: none;
				}

				table {
					width: 100%;
					border-collapse: collapse;
					table-layout: fixed;
					margin-bottom: 20px;

					thead {
						width: 100%;

						tr {
							background: #f7f7f7;
							color: #333;
							height: 48px;
							line-height: 48px;
							border-bottom: 1px solid #ededed;
							text-align: center;
						}
					}

					tbody {
						width: 100%;

						tr {
							background: #f7f7f7;
							color: #333;
							height: 60px;
							line-height: 60px;
							border-bottom: 1px solid #e7f7eb;
							text-align: center;
						}
					}

					.team-name {
						width: 240px;
						text-align: left;
						padding-left: 20px;

						img {
							width: 30px;
							height: 30px;
							margin: 0 10px 0 0;
							position: relative;
							bottom: -10px;
						}
					}

				}
			}
		}

		.against_plan {
			img {
				max-width: 100%;
			}
		}
	}
}
</style>
